import { IDisburseAllDisbursementData } from 'types/order/escrow/IDisburseAllDisbursementData';
import { IDisbursementDictionary } from './IDisbursementDictionary';
import { useGetEscrowBalancesDataQuery } from 'API/order/escrow/EscrowBaseAPI';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { assertDefined } from 'utilities/Assertions';

export const useGetTotals = (disbursements: IDisbursementDictionary) => {
  const totalOutgoing =
    disbursements.ACH.reduce(sumUpDisbursements, 0) +
    disbursements.Check.reduce(sumUpDisbursements, 0) +
    disbursements['Internal Transfer'].reduce(sumUpDisbursements, 0) +
    disbursements.Wire.reduce(sumUpDisbursements, 0);

  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);

  const { data } = useGetEscrowBalancesDataQuery(orderId);

  const hasEnoughMoney = Math.round((data?.availableAmountDollars ?? 0) * 100) >= Math.round(totalOutgoing);

  return {
    total: totalOutgoing,
    available: data?.availableAmountDollars ?? 0,
    isEnough: hasEnoughMoney,
  };
};

const sumUpDisbursements = (p: number, c: IDisburseAllDisbursementData) =>
  p + (c.enabled ? c.disbursement.amountCents ?? 0 : 0);
